import {EventEmitter, Injectable, SimpleChange} from '@angular/core';
import {ElectronService} from 'ngx-electron';
import buildFile from '../../../../../buildNumber.json';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {

  private AppWindowState: AppWindowState = AppWindowState.Login;
  appWindowStateChange: EventEmitter<SimpleChange> = new EventEmitter<SimpleChange>();

  frontEndBuildNumber: string = buildFile.buildNumber;

  get appWindowState() {
    return this.AppWindowState;
  }

  set appWindowState(value: AppWindowState) {
    const previousValue = this.AppWindowState;
    this.AppWindowState = value;
    this.appWindowStateChange.emit(new SimpleChange(previousValue, value, false));
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.AppStateService, `App window state changed from ${AppWindowState[previousValue]} to ${AppWindowState[value]}`);
  }

  constructor(private electronService: ElectronService,
              private loggerService: LoggerService) {

    if (this.electronService.isElectronApp) {
      this.electronService.ipcRenderer.on('save-state-and-quit', async () => {
        this.electronService.ipcRenderer.send('exit', {force: false});
      });
    }

    this.clearLocalStorageOnVersionChange();
  }

  private clearLocalStorageOnVersionChange() {
    const frontendVersion = localStorage.getItem('frontend-version');
    if (!frontendVersion || frontendVersion !== buildFile.buildNumber) {
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.AppStateService, `Frontend version changed from ${frontendVersion} to ${buildFile.buildNumber}. Clearing local storage.`);
      localStorage.clear();
      localStorage.setItem('frontend-version', buildFile.buildNumber);
    }
  }
}

export enum AppWindowState {
  Headless = 'Headless',
  ForceUpdate = "ForceUpdate",
  Login = 'login',
  Tenant = 'tenant',
  Loading = 'loading',
  Main = 'main',
  Settings = 'settings',
  Help = 'help',
  About = 'about',
  ForgotPassword = 'forgotPassword',
  Register = 'register',
}
